// extracted by mini-css-extract-plugin
export default {"container":"SnackBar__container__GzQus","content":"SnackBar__content__ch6_I","text":"SnackBar__text__oJw6P","message":"SnackBar__message__bHDgx","action":"SnackBar__action__AbIt9"};
    if(module.hot) {
      // 1763020727662
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  